import { IDynamicLinkedServiceTypeMetadata, ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { ConnectionAuthKind } from 'shell-models-lib';
import { FabricDataPipelinesLinkedService } from 'app/model/linkedservice/fabric-data-pipelines.linkedservice';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { compact } from 'lodash';

export const fabricDataPipelinesMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {    
    const metadata: ILinkedServiceTypeMetadata = {
        type: Metamodel.modelFor(FabricDataPipelinesLinkedService).name,
        displayName: stringResources.FabricDataPipelines,
        icon: {
            className: 'svg-i_fabric_16x16'
        },
        supportedAuthKindsInTrident: compact([
            ConnectionAuthKind.OAuth2,
            ConnectionAuthKind.ServicePrincipal,
            ConnectionAuthKind.WorkspaceIdentity
        ]),
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'FabricDataPipelines' as ResourceKind
        },
        supportOPDG: true,
        category: ['Compute'],
        copySourceTypes: [],
        copySinkTypes: [],
        supportedInTrident: true,
        isCompute: true,
        isFirstClass: true,
        disableQueryAPI: true,
        supportFirstClassParameterExperience: true,
    };
    return metadata;
}
